import React from 'react';
import phoneicon from '../images/phoneicon.png'
import playstore from '../images/playstore.png'
import './Navbar.css';

function Main() {

    return (
        <div className="App" id='home'>
            <header className="App-header" s>
                <h3 className='mb-5'>Welcome to Tring Tring: Predict and Win for FREE !</h3>
                <p>Predict daily and win exciting prizes!</p>
                <p>Join us for an unforgettable gaming experience that's</p>
                <p><strong>simple, fun, and rewarding.</strong></p>
            </header>

            <main className='App-main'>
                <h2>You can also make prediction using</h2>
                <div className='phone'>
                    <div>
                        <a href='tel:9900999009'><img width="50px" src={phoneicon} alt='Phone logo'></img></a>
                    </div>
                    <div>
                        <h5 className='text-left'>Phone Call and IVR </h5>
                        <h3>Coming Soon</h3>
                    </div>
                </div>
                <div>
                    <h3>or</h3>
                </div>
                <div>
                    <img width="200px" src={playstore} alt='playstore Logo' />
                </div>
            </main>

            <main className='App-works' id='how-it-works'>
                <h2 className='mb-4'>How it Works ?</h2>
                <p><strong>Predict & Play:</strong> Make your predictions for a unique set of numbers, typically a 5-digit combination, using your phone. You can participate through phone calls, our mobile app, or an IVR system.</p>

                <p><strong>Daily Predictions:</strong> We host daily prediction rounds, with each round typically taking place at 9:00 PM. Your predictions up to a specific time count for that day's round.</p>

                <p><strong>Win Exciting Giveaways:</strong> If your prediction matches the randomly generated winning number of the day, you're a winner! We offer thrilling giveaways that add an extra layer of excitement to your win.</p>

                <p><strong>Instant Gratification:</strong> No need to wait for your prizes. Winners receive their rewards directly to their mobile wallets or payment apps like Paytm, PhonePe, or Google Pay.</p>
            </main>
            {/* <main className='App-prizes' id="prizes-list">
                <h2 className='mb-4'>Prize List</h2>
                <p><strong>Predict & Play:</strong> Make your predictions for a unique set of numbers, typically a 5-digit combination, using your phone. You can participate through phone calls, our mobile app, or an IVR system.</p>

                <p><strong>Daily Predictions:</strong> We host daily prediction rounds, with each round typically taking place at 9:00 PM. Your predictions up to a specific time count for that day's round.</p>

                <p><strong>Win Exciting Giveaways:</strong> If your prediction matches the randomly generated winning number of the day, you're a winner! We offer thrilling giveaways that add an extra layer of excitement to your win.</p>

                <p><strong>Instant Gratification:</strong> No need to wait for your prizes. Winners receive their rewards directly to their mobile wallets or payment apps like Paytm, PhonePe, or Google Pay.</p>
            </main> */}

            <footer className="App-footer">
                <p>&copy; {new Date().getFullYear()} Tring Tring</p>
                <p><a href='/privacy'>Terms & Conditions | Privacy Policy</a></p>
            </footer>
        </div>
    );
}

export default Main;

